/* Quality indicators (docs/plans/phase3-khis-and-quality.md §4). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-4);
}

.prose {
  max-width: 75ch;
  margin: 0;
  font-variant-numeric: tabular-nums;
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.definition summary {
  color: var(--color-primary);
  cursor: pointer;
}

.definition summary:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.definition p {
  margin-top: var(--space-2);
}
